import * as statuses from '../../states';

export const FETCH_ROLE_REQUEST = 'FETCH_ROLE_REQUEST';
export const FETCH_ROLE_SUCCEEDED = 'FETCH_ROLE_SUCCEEDED';
export const FETCH_ROLE_FAILED = 'FETCH_ROLE_FAILED';
export const SET_ROLES = 'SET_ROLES';


export interface AuthState {
    status: typeof statuses[keyof typeof statuses];
    roles: string[];
    isConnected: boolean;
    email: string;
    username: string;
    firstname: string;
    lastname: string;
    phone: string;
    iss: number;
}

export interface AuthDecode {
    iss: number;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    roles: string[];
    exp: number;
}